'use client';
import { useEffect } from 'react';

import { usePathname, useSearchParams } from 'next/navigation';

interface PageEventProps {
  event: string;
  page: string;
}

export const pageView = (url: string) => {
  if (typeof window !== 'undefined') {
    const pageEvent: PageEventProps = {
      event: 'pageview',
      page: url,
    };
    window.dataLayer && window.dataLayer.push(pageEvent as never);
  }
};

export const GTMPageView = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname) {
      // Construct full URL with search params if they exist
      const url = searchParams?.toString()
        ? `${pathname}?${searchParams}`
        : pathname;

      pageView(url);
    }
  }, [pathname, searchParams]);

  return null;
};
